import { AnimatePresence } from "framer-motion";
import Navbar from "./Navbar";
import AboutHeader from "./About/About_section_Header";
import AboutSection from "./About/About_Us";
import PresidentMessage from "./About/President__Message";
import OurTeam from "./About/Our_Team";
import OurSpirit from './About/Spirit';
import FacultyCardGrid from "./About/Our_Faculty";
import FAQSection from "./About/FAQ";
import Gallery from "./About/Gallery";
import AnimatedCard from "./About/Animated_Card";
import Footer from "./Footer";
import './Css/About.css';

function About() {
  return (
    <AnimatePresence>
      <Navbar />
      <AboutHeader />
      <AboutSection />
      <PresidentMessage />
      <AnimatedCard />
      <OurSpirit />
      <OurTeam />
      <FacultyCardGrid />
      <FAQSection />
      <Gallery />
      <Footer />
    </AnimatePresence>
  );
}

export default About;